// src/components/HistoryBridge.js
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// produção: pai (Weebly)
const PARENT_ORIGIN = "https://www.termometrooscar.com";

function inIframe() {
  try { return window.self !== window.top; } catch { return true; }
}

// Quando usamos HashRouter, a rota “real” está no hash.
// Normalizamos o que sai (para o pai) e o que entra (do pai).
function normalizeOut(location) {
  // Preferir o hash puro: "#/perfil/..." -> "/perfil/..."
  const h = location.hash || "";
  if (h.startsWith("#/")) return h.slice(1);
  // fallback (se algum dia mudarem o router)
  return (location.pathname || "/") + (location.search || "");
}
function normalizeIn(path) {
  if (!path) return "/";
  if (path.startsWith("/#/")) return path.replace("/#/", "/"); // "/#/" -> "/"
  if (path.startsWith("#/")) return path.slice(1);            // "#/..." -> "/..."
  return path;
}

export default function HistoryBridge() {
  const location = useLocation();
  const navigate = useNavigate();

  // Envia a rota atual para o Weebly
  useEffect(() => {
    if (!inIframe()) return;
    const path = normalizeOut(location);
    try {
      window.parent.postMessage({ type: "TM_ROUTE", path }, PARENT_ORIGIN);
    } catch {}
  }, [location]);

  // Escuta comandos do Weebly
  useEffect(() => {
    if (!inIframe()) return;

    function onMessage(e) {
      if (e.origin !== PARENT_ORIGIN) return;
      const data = e.data || {};

      if (data.type === "TM_NAVIGATE" && typeof data.path === "string") {
        const wanted = normalizeIn(data.path);
        const current = normalizeOut(location);
        if (wanted !== current) navigate(wanted, { replace: false });
      }
      if (data.type === "TM_BACK") window.history.back();
      if (data.type === "TM_FORWARD") window.history.forward();
    }

    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, [navigate, location]);

  // Sinaliza pronto
  useEffect(() => {
    if (!inIframe()) return;
    try { window.parent.postMessage({ type: "TM_READY" }, PARENT_ORIGIN); } catch {}
  }, []);

  return null;
}
